import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-freelayout',
  templateUrl: './freelayout.component.html',
  styleUrls: ['./freelayout.component.css']
})
export class FreelayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
